import { memo, useLayoutEffect, useMemo, useRef } from 'react'
import { Routes } from 'react-router-dom'
import { FaArrowLeft } from 'react-icons/fa6'
import { CurrentTabContext, useTabs } from './TabsContext'
import TabErrorBoundary from './TabErrorBoundary'

// Her sekme kendi adresiyle render edilir; useParams/useLocation sekmeye özel çalışır
const TabPanel = memo(({ id, path, active, canGoBack, routes, refreshTab, goBack }) => {
    const ref = useRef()
    const scrollTop = useRef(0)
    const isMounted = useRef(false)
    const currentTab = useMemo(() => ({ id }), [id])

    // display:none kaydırma konumunu sıfırladığı için sekmeye dönüldüğünde geri yüklenir
    useLayoutEffect(() => {
        if (active) ref.current.scrollTop = scrollTop.current
    }, [active])

    // Sekme içinde başka sayfaya geçildiğinde (ör. yeni kayıt formu) en üstten başlanır
    useLayoutEffect(() => {
        if (isMounted.current) {
            ref.current.scrollTop = 0
            scrollTop.current = 0
        }
        isMounted.current = true
    }, [path])

    return (
        <div
            ref={ref}
            className={active ? 'h-full overflow-auto px-5 pb-5' : 'hidden'}
            onScroll={e => { scrollTop.current = e.currentTarget.scrollTop }}
        >
            {
                canGoBack &&
                <span
                    className='inline-flex items-center gap-x-1 mb-2 cursor-pointer text-sm text-zinc-600 hover:text-purple-700 duration-150 dark:text-zinc-300'
                    onClick={() => goBack(id)}
                >
                    <FaArrowLeft />
                    Geri
                </span>
            }
            <CurrentTabContext.Provider value={currentTab}>
                <TabErrorBoundary onReload={() => refreshTab(id)}>
                    <Routes location={path}>{routes}</Routes>
                </TabErrorBoundary>
            </CurrentTabContext.Provider>
        </div>
    )
})

const TabPanels = ({ routes }) => {
    const { tabs, activeId, refreshTab, goBack } = useTabs()

    return (
        <div className='flex-1 min-h-0'>
            {
                tabs.map(tab => (
                    <TabPanel
                        key={`${tab.id}:${tab.version}`}
                        id={tab.id}
                        path={tab.path}
                        active={tab.id === activeId}
                        canGoBack={tab.back.length > 0}
                        routes={routes}
                        refreshTab={refreshTab}
                        goBack={goBack}
                    />
                ))
            }
        </div>
    )
}

export default TabPanels
